module.exports = __webpack_public_path__ + "media/images/img-realestate-2-6e598e64.png";